import { useEffect, useState } from 'react'
import { postHttp } from 'src/api'
import { PATH_API } from 'src/helpers/path'
import { useAppContext } from 'src/helpers/app'
import { getQueryParameters } from 'src/helpers/tool'

export const useBulkRecord = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [isCompleted, setIsCompleted] = useState(false)
  const { sessionID, storeURLParameters } = useAppContext()

  const callBulkRecord = async () => {
    try {
      setIsLoading(true)
      setError(null)

      // Get selectedFlowers from localStorage
      const params = getQueryParameters()
      const collectionId =
        params.get('collectionId') || JSON.parse(localStorage.getItem('collectionsQuizEntry') || '{}').collectionId

      let selectedImageIds: number[] = []
      if (!collectionId) {
        const selectedFlowersData = localStorage.getItem('selectedFlowers')
        if (!selectedFlowersData) {
          throw new Error('No selected flowers found in localStorage')
        }
        const selectedFlowers = JSON.parse(selectedFlowersData)
        selectedImageIds = selectedFlowers.map((flower: any) => flower.id)
        if (!selectedImageIds.length) {
          throw new Error('No flower IDs found')
        }
      }

      // Call bulk record API
      const response = await postHttp(PATH_API.bulkRecord, {
        uniqueIdentifier: sessionID,
        selectedImageIds,
        urlParameters: storeURLParameters ?? undefined,
      })

      // Save top collections if available
      if (response?.topCollections) {
        let topCollections = response.topCollections
        if (Array.isArray(topCollections)) {
          const obj: Record<string, any> = {}
          topCollections.forEach((item: any) => {
            if (item && item.name) obj[item.name] = item
          })
          topCollections = obj
        }
        localStorage.setItem('topCollections', JSON.stringify(topCollections))
      }

      setIsCompleted(true)
      return response
    } catch (error) {
      console.error('Error calling bulk record API:', error)
      setError(error instanceof Error ? error.message : 'Failed to process flower selections')
      throw error
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    // Only call bulk record if no collectionId
    const params = getQueryParameters()
    const collectionId =
      params.get('collectionId') || JSON.parse(localStorage.getItem('collectionsQuizEntry') || '{}').collectionId
    if (!collectionId) {
      callBulkRecord()
    }
  }, [])

  return {
    isLoading,
    error,
    isCompleted,
    callBulkRecord,
  }
}
